/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnAssignProjectFromProgramCommand } from '../../models/un-assign-project-from-program-command';
import { UnAssignProjectFromProgramCommandResult } from '../../models/un-assign-project-from-program-command-result';

export interface ApiProjectUnAssignProjectFromProgramPost$Plain$Params {
      body?: UnAssignProjectFromProgramCommand
}

export function apiProjectUnAssignProjectFromProgramPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectUnAssignProjectFromProgramPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UnAssignProjectFromProgramCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectUnAssignProjectFromProgramPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnAssignProjectFromProgramCommandResult>;
    })
  );
}

apiProjectUnAssignProjectFromProgramPost$Plain.PATH = '/api/Project/UnAssignProjectFromProgram';
